import { Component } from '@angular/core';
import { OperationDto } from '../../../api/dtos/OperationDto';
import { OperationService } from './operation.service';
import { OperationStatus } from '../../../api/enums/OperationStatus';
import { ModalService } from '../../../../../../libs/utils/ng-shared-components/src/lib/services/modal.service';
import { NotificationService } from '../../../../../../libs/utils/ng-shared-components/src';

@Component({
  standalone: false,
  selector: 'mf-operation-create',
  templateUrl: './operation-create.component.html',
  styleUrls: ['./operation-create.component.scss'],
})
export class OperationCreateComponent {
  constructor(
    private _operationService: OperationService,
    private _modalService: ModalService,
    private _notificationService: NotificationService
  ) {
    this._operationService.operationDto = new OperationDto();
    this._operationService.operationDto.status = OperationStatus.Draft;
  }

  async save(operationDto: OperationDto) {
    await this._operationService.createDraft(operationDto);
    this._modalService.closeAsSuccess();
    this._notificationService.showSuccess('Operación creada correctamente en estado Borrador');
  }
}
